<template>
    <b-container id="register" class="user-form">
        <b-row>
            <b-col>
                <h3>{{ getLanguage.calendarText.headerRegister }}</h3>
                <div v-if="success">
                    <div v-if="errorMsg == ''">
                        <span v-html="getLanguage.success.register"></span>
                    </div>
                </div>
                <p v-if="errorMsg != ''" class="error" v-html="errorMsg">{{ errorMsg }}</p>
                <div v-if="!success">
                    <ValidationObserver v-slot="{ handleSubmit }">
                        <b-form @submit.prevent="handleSubmit(onSubmit)">
                            <b-form-group :label="`${getLanguage.formEmail}:*`">
                                <Validation-provider name="email" rules="required|email" v-slot="{ errors }">
                                    <b-form-input v-model="form.email" type="email" trim required @focusout="checkEmail"></b-form-input>
                                    <span class="note">{{ errors[0] }}</span>
                                </Validation-provider>
                            </b-form-group>
                            <b-form-group :label="`${getLanguage.formPassword}:*`">
                                <Validation-provider name="password" rules="required|min:8|confirmed:password_confirmation" v-slot="{ errors }">
                                    <b-form-input v-model="form.password" ref="password" type="password" trim required></b-form-input>
                                    <span class="note">{{ errors[0] }}</span>
                                </Validation-provider>
                            </b-form-group>
                            <b-form-group :label="`${getLanguage.formPassword2}:*`">
                                <Validation-provider v-slot="{ errors }" vid="password_confirmation">
                                    <b-form-input v-model="form.password_confirmation" type="password" trim required></b-form-input>
                                    <span class="note">{{ errors[0] }}</span>
                                </Validation-provider>
                            </b-form-group>
                            <b-row>
                                <b-col>
                                    <b-form-group :label="`${getLanguage.formSurname}:*`">
                                        <Validation-provider name="vorname" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="form.name" trim required></b-form-input>
                                            <span class="note">{{ errors[0] }}</span>
                                        </Validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group :label="`${getLanguage.formLastname}:*`">
                                        <Validation-provider name="nachname" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="form.lastname" trim required></b-form-input>
                                            <span class="note">{{ errors[0] }}</span>
                                        </Validation-provider>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group :label="`${getLanguage.formStreet}:`">
                                        <b-form-input v-model="form.street" trim></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group :label="`${getLanguage.formPlz}:`">
                                        <b-form-input v-model="form.postcode" trim></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group :label="`${getLanguage.formCity}:`">
                                        <b-form-input v-model="form.city" trim></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group :label="`${getLanguage.formPhone}:`">
                                        <b-form-input v-model="form.phone" trim></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group :label="`${getLanguage.formCountry}:`">
                                        <b-form-select v-model="form.country" :options="options"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-button type="submit" variant="primary">{{ getLanguage.formBtnRegister }}</b-button>
                        </b-form>
                    </ValidationObserver>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
    import { required, email, min, confirmed } from 'vee-validate/dist/rules';
    import { dataService } from "../shared";
    import { helpers } from '../shared/mixin';
    import { mapGetters } from "vuex";
    import store from '../store';

    let messages = {
        required: 'Dieses Feld muss eingegeben werden!',
        email: 'Bitte korrekte Email Adresse eingeben.',
        confirmed: 'Bitte Passwort im folgenden Feld erneut eingeben.',
        min: 'Dieses Feld benötigt min. {length} Zeichen.'
    };

    let countries = [
        { value: 'DE', text: 'Deutschland' },
        { value: 'AT', text: 'Österreich' },
        { value: 'CH', text: 'Schweiz' },
    ];

    if (store.getters.getLangCode != 'de') {
        messages = {
            required: 'This field is required!',
            email: 'Please enter correct email address.',
            confirmed: 'Please confirm the password in the following field.',
            min: 'This field requires at least {length} characters.'
        };

        countries = [
            { value: 'AT', text: 'Austria' },
            { value: 'HR', text: 'Croatia' },
            { value: 'DE', text: 'Germany' },
            { value: 'CH', text: 'Switzerland' },
        ];
    }

    // validation
    extend('email', {
        ...email,
        message: messages.email
    });
    extend('confirmed', {
        ...confirmed,
        message: messages.confirmed
    });
    extend('min', {
        ...min,
        validate(value, { length }) {
            return value.length >= length;
        },
        params: ['length'],
        message: messages.min
    });
    extend('required', {
        ...required,
        message: messages.required
    });

    export default {
        name: "UserRegister",
        components: {
            ValidationProvider,
            ValidationObserver
        },
        mixins: [ helpers ],
        data() {
            return {
                form: {
                    email: '',
                    password: '',
                    password_confirmation: '',
                    name: '',
                    lastname: '',
                    street: '',
                    postcode: '',
                    city: '',
                    phone: '',
                    country: countries[0].value,
                },
                errorMsg: '',
                success: false,
                options: countries
            }
        },
        methods: {
            async onSubmit()
            {
                const response = await dataService.register(this.form);

                if (response.status == 422) {
                    this.errorMsg = this.showErrors(response.data);
                } else {
                    this.success = true;
                }
            },
            async checkEmail()
            {
                const response = await dataService.checkUserEmail(this.form.email);

                if (response.data > 0)
                {
                    this.success = true;

                    let message = 'Diese Email Adresse ist bereits vorhanden, du kannst dich mit deinen bestehenden Login Daten direkt anmelden!';

                    if (this.getLangCode != 'de') {
                        message = 'This email address already exists, you can register directly with your existing login data!';
                    }

                    this.errorMsg = message;
                }
            }
        },
        computed: {
            ...mapGetters(['getLanguage', 'getLangCode']),
        }
    }
</script>

<style scoped>

</style>